var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactjs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_66_1046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5555 16.963C17.1919 16.963 18.5185 15.6365 18.5185 14.0001C18.5185 12.3637 17.1919 11.0371 15.5555 11.0371C13.9191 11.0371 12.5925 12.3637 12.5925 14.0001C12.5925 15.6365 13.9191 16.963 15.5555 16.963Z",
    fill: "#149ECA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5555 20.6666C23.7375 20.6666 30.3703 17.6818 30.3703 13.9999C30.3703 10.318 23.7375 7.33325 15.5555 7.33325C7.37354 7.33325 0.740723 10.318 0.740723 13.9999C0.740723 17.6818 7.37354 20.6666 15.5555 20.6666Z",
    stroke: "#149ECA",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.78203 17.3333C13.873 24.4191 19.7743 28.6709 22.9629 26.83C26.1516 24.9891 25.42 17.7525 21.329 10.6667C17.238 3.58086 11.3367 -0.670947 8.14813 1.17C4.95951 3.01095 5.69104 10.2475 9.78203 17.3333Z",
    stroke: "#149ECA",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.78217 10.6668C5.69117 17.7526 4.95965 24.9891 8.14827 26.8301C11.3369 28.671 17.2382 24.4192 21.3292 17.3334C25.4202 10.2476 26.1517 3.01103 22.9631 1.17009C19.7745 -0.670862 13.8732 3.58094 9.78217 10.6668Z",
    stroke: "#149ECA",
    strokeWidth: 1.11111
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_1046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.1111,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjs);
export default __webpack_public_path__ + "static/media/react.js.30617dfff29e092824ad3ded69bcb0d4.svg";
export { ForwardRef as ReactComponent };